import React from 'react';

const Details = () => {
    return (<>
        <span 
            className='mr-2' 
            style={{ display: 'inline-block', textAlign: 'center', width: '100%' }}>
                Details
        </span>
    </>)
}

export default Details;